import { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import { useFetchLines } from './use-fetch-lines';
import { useFetchCompanies } from './use-fetch-companies';

export const useFetchFilteredLinesByCompany = (
  config = { lineRequest: {}, boStrip: false, boWithUsers: false }
) => {
  const [filteredLines, setFilteredLines] = useState([]);
  const { values, setFieldValue } = useFormikContext();

  const { loading: LoadingLines, lines } = useFetchLines({ boSlic: !config.boStrip, ...config.lineRequest });
  const { loading: loadingCompanies, companies } = useFetchCompanies(config);
  const loading = LoadingLines || loadingCompanies;

  useEffect(() => {
    if (!values.empresas) return;
    if (values.empresas.length === 0) {
      setFilteredLines(lines);
    } else {
      setFilteredLines(filterLinesByCompany(values.empresas, lines));
    }
  }, [values.empresas, lines]);

  useEffect(() => {
    if (!values.linhas) return;
    if (!values.empresas) return;
    const lineList = getLineObjectsFromIds(values.linhas, lines);
    const filtered = filterLinesByCompany(values.empresas, lineList);
    const onlyCdLinha = filtered.map(line => line.cdLinha);

    setFieldValue('linhas', onlyCdLinha);
    // eslint-disable-next-line
  }, [values.empresas]);

  return { lines: filteredLines, companies, loading };
};

function filterLinesByCompany(companiesIds, linesList) {
  let filtered = [];
  companiesIds.forEach(companyId => {
    const companyLines = linesList.filter(line => +line.cdEmpresa === +companyId);
    filtered = [...filtered, ...companyLines];
  });
  return filtered;
}

function getLineObjectsFromIds(idList, lineList) {
  let filtered = [];
  idList.forEach(lineId => {
    const foundLine = lineList.find(line => +line.cdLinha === +lineId);
    if (foundLine) filtered.push(foundLine);
  });
  return filtered;
}
